module.exports = __webpack_public_path__ + "img/icon_sb_rating_alt_mob_v1.cba16d4.svg";